module.exports = __webpack_public_path__ + "img/BANVIET.f085b962.svg";